import { apiSpiderMapBaseURL } from '../../authentication/Global';
import { authenticationCentral } from '../../authentication/Authentication';
import { API, HTTPMethod, ContentType } from '../APICentral';

const uploadsApiRoutes = {
    uploadSettingsImage: apiSpiderMapBaseURL + "settings/upload-stop-image/",
};

export class UploadsAPI {
    static uploadStopImage(stopId, form) {
        return API.authenticatedRequest({
            url: new URL(stopId, uploadsApiRoutes.uploadSettingsImage),
            method: HTTPMethod.POST,
            contentType: ContentType.MULTIPART,
            token: authenticationCentral.accessToken,
            body: form
        });
    }
}


// WEBPACK FOOTER //
// ./src/api/spidermap/UploadsAPI.js